// extracted by mini-css-extract-plugin
export default {"wrapper":"View404_wrapper__cOS+l","backLink":"View404_backLink__siL-X"};